/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bsv_Chain_Max_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "BSV operates as a PoW network, where block times vary significantly due to the nature of the mining process. In some cases, when a miner solves the cryptogra..." |
*
* @param {Bsv_Chain_Max_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bsv_chain_max_tps_explanation = /** @type {((inputs?: Bsv_Chain_Max_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bsv_Chain_Max_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("BSV operates as a PoW network, where block times vary significantly due to the nature of the mining process. In some cases, when a miner solves the cryptographic puzzle unusually quickly, a new block can be created in just seconds.<br /><br />This variability explains why BSV’s <strong>Max TPS (1 block)</strong> can exceed its <strong>Max Theoretical TPS</strong>.")
});